// extracted by mini-css-extract-plugin
export var chip = "_2g-9";
export var chipLabel = "_2g-a";
export var close = "_2g-7";
export var closeIcon = "_2g-8";
export var error = "_2g-6";
export var infoTooltip = "_2g-2";
export var innerContainer = "_2g-1";
export var input = "_2g-b";
export var medium = "_2g-5";
export var outerContainer = "_2g-0";
export var small = "_2g-4";
export var xSmall = "_2g-3";